import {
  ACCOUNT_STATEMENT_ROUTE,
  AFFILIATE_PROGRAM_ROUTE,
  BONUS_STATEMENT_ROUTE,
  DEPOSIT_ROUTE,
  fetchBalance,
  HOME_ROUTE,
  IN_PLAY_ROUTE,
  LOGIN_ROUTE,
  logout,
  MY_BETS_ROUTE,
  MY_PROFILE_ROUTE,
  MY_TRANSACTION_ROUTE,
  // MY_WALLET_ROUTE,
  PROFIT_LOSS_REPORT_ROUTE,
  RootState,
  STAKE_SETTINGS_ROUTE,
  TURNOVER_REPORT_ROUTE,
  useAppDispatch,
  useAppSelector,
  WITHDRAW_ROUTE,
  UserMenuEnum,
  getUsername,
  notDemoUser,
  getLangData,
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
  showToast,
} from "@hypexone/uicore";
import { useEffect, useRef, useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserIcon from "../../../assets/images/Casino_svg_img/User_Icon.svg";
import logo from "../../../assets/images/brand/title.png";
import { headerGradient } from "../../../utils/constants/common.constants";
import MenuComponent from "../shared/MenuComponent";
import NewsAndPromotions from "../shared/NewsAndPromotions";
import HeaderButtonComponent from "./HeaderButtonComponent";
import HeaderSearchInput from "./HeaderSearchInput";
import LoginButtons from "./LoginButtons";
import SubHeader from "./SubHeader";
import Modal from "../shared/ExpModal";
import Button from "../shared/Button/Button";
import ChangeLanguageModal from "../user-menu-pages/ChangeLanguageModal";
import AllOpenBets from "../user-menu-pages/OpenBets/AllOpenBets";
import SkinOptions from "./SkinOptions";
import SkinIcon from "../../../assets/icons/header-icons/skins-icon.svg";
import IndigoSkinIcon from "../../../assets/icons/header-icons/skin.svg";
import { ChevronDown, RefreshCw } from "lucide-react";
import { FaGear } from "react-icons/fa6";
import { FaInfoCircle } from "react-icons/fa";
import CasinoChipIcon from "../../../assets/icons/header-icons/casino-chip-gold.svg";
import { getEnvVariable } from "../../../constants/brandConfig";
import { domain, HOUSE_NAME } from "../../../constants/Branding";
import WithdrawAndDepositBar from "./WithdrawAndDepositBar";
interface HeaderProps {
  disableSportsSubheader?: boolean;
  balance: number;
  exposure: number;
  loggedIn: boolean;
}

const Header: React.FC<HeaderProps> = ({
  disableSportsSubheader,
  balance,
  exposure,
  loggedIn,
}) => {
  const [showOpenBets, setShowOpenBets] = useState<boolean>(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const dispatch = useAppDispatch();
  const pathName = useLocation().pathname;
  const [Balance, setBalance] = useState<string | number>(balance);
  const [Exposure, setExposure] = useState<string | number>(exposure);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const hasInplayInPath = pathName.includes(IN_PLAY_ROUTE);

  const navigate = useNavigate();
  const { domainConfig } = useAppSelector((state) => state.common);
  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;

  const downloadApp = () => {
    if (!apkUrl) return;
    const link = document.createElement("a");
    link.href = apkUrl.startsWith("http") ? apkUrl : `https://${apkUrl}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const balanceSummary = useAppSelector((state) => state.auth.balanceSummary);
  const openBets = useAppSelector((state) => state.betSlip.openBets) ?? [];
  const [showTooltip, setShowTooltip] = useState(false);
  const mobileTooltipRef = useRef<HTMLDivElement>(null);
  const cashableDisplay = (Number(balanceSummary?.cashableAmount / cFactor) ?? 0).toFixed(2);
  const nonCashableDisplay = domainConfig?.payments
    ? Math.max(
        Number(exposure / cFactor) || 0,
        (Number(balanceSummary?.nonCashableAmount / cFactor) || 0) + (Number(balanceSummary?.bonusRedeemed / cFactor) || 0)
      ).toFixed(2)
    : "0";
  const showBalanceInfoIcon =
    domainConfig?.depositWagering && domainConfig?.b2cEnabled;

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isSkinOpen, setIsSkinOpen] = useState(false);
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (!isMobile || !showTooltip) return;
    const handleClickOutside = (e: MouseEvent | TouchEvent) => {
      const el = mobileTooltipRef.current;
      if (el && !el.contains(e.target as Node)) setShowTooltip(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isMobile, showTooltip]);

  const userMenuList = [
    {
      title: UserMenuEnum.MY_PROFILE,
      navigationUrl: MY_PROFILE_ROUTE,
      enabled: true,
    },
    { title: UserMenuEnum.HOME, navigationUrl: HOME_ROUTE },
    {
      title: UserMenuEnum.ACCOUNT_STATEMENT,
      navigationUrl: ACCOUNT_STATEMENT_ROUTE,
      enabled: true,
    },
    {
      title: UserMenuEnum.PROFIT_LOSS_REPORT,
      navigationUrl: PROFIT_LOSS_REPORT_ROUTE,
      enabled: true,
    },
    // {
    //   title: UserMenuEnum.MY_WALLET,
    //   navigationUrl: MY_WALLET_ROUTE,
    //   enabled: true,
    // },
    // {
    //   title: UserMenuEnum.TURNOVER_REPORT,
    //   navigationUrl: TURNOVER_REPORT_ROUTE,
    //   enabled: true,
    // },
    {
      title: UserMenuEnum.AFFILIATE_PROGRAM,
      navigationUrl: AFFILIATE_PROGRAM_ROUTE,
      enabled: domainConfig.affiliate && notDemoUser(),
    },
    {
      title: UserMenuEnum.TURNOVER_REPORT,
      navigationUrl: TURNOVER_REPORT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    {
      title: UserMenuEnum.BONUS_STATEMENT,
      navigationUrl: BONUS_STATEMENT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    // {
    //   title: "deposit_turnover", //add to ui core
    //   navigationUrl: "/deposit-turnover", //add route to ui core
    //   enabled: true,
    // },
    {
      title: "Promotions", //add to ui core
      navigationUrl: "/promotions", //add route to ui core
      enabled: true,
    },
    {
      title: UserMenuEnum.MY_TRANSACTION,
      navigationUrl: MY_TRANSACTION_ROUTE,
      enabled: domainConfig.payments && notDemoUser(),
    },
    {
      title: UserMenuEnum.STAKE_SETTINGS,
      navigationUrl: STAKE_SETTINGS_ROUTE,
      enabled: notDemoUser(),
    },
    {
      title: UserMenuEnum.MY_BET,
      navigationUrl: MY_BETS_ROUTE,
      enabled: true,
    },
    {
      title: "2FA",
      navigationUrl: `${MY_PROFILE_ROUTE}?tab=2fa`,
      enabled: true,
      langKey: "two_factor_auth",
    },
    {
      title: "Download APK",
      enabled: !!apkUrl,
      langKey: "download_apk",
      isDownloadApk: true,
    },
    {
      title: "Language",
      enabled: true,
      langKey: "language",
      openLanguageModal: true,
    },
    {
      title: "Change Password",
      navigationUrl: "/change-password",
      enabled: true,
    },
    {
      title: "Rules and Regulations",
      navigationUrl: "/rules",
      enabled: true,
    },
    {
      title: UserMenuEnum.SIGNOUT,
      navigationUrl: LOGIN_ROUTE,
      enabled: true,
    },
  ];
  const { langData } = useAppSelector((state) => state.cms);

  useEffect(() => {
    const selectedLang = sessionStorage.getItem("lang")
      ? sessionStorage.getItem("lang")
      : "en";
    dispatch(getLangData(selectedLang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ToggleSkins = () => {
    return (
      <MenuComponent
        menuTitle={
          <img
            src={HOUSE_NAME === 'indigo' ? IndigoSkinIcon : SkinIcon}
            className={
              HOUSE_NAME === 'indigo'
                ? "min-w-6 min-h-6 w-6 h-6"
                : "min-w-7 min-h-7 w-7 h-7"
            }
            alt="skins"
          />
        }
        menuList={<SkinOptions />}
        isOpen={isSkinOpen}
        closeMenu={() => setIsSkinOpen(false)}
        toggleMenu={() => setIsSkinOpen(!isSkinOpen)}
        alignDropdownToCorner
        customButtonCss="!p-0"
      />
    );
  };

  const websiteUrls = getEnvVariable(domain, "skins") || [];
  const switchableSkinsCount = websiteUrls.filter((skin) => !skin.disabled).length;
  const showToggleSkins =
    switchableSkinsCount > 0 &&
    HOUSE_NAME !== "cricket100" &&
    HOUSE_NAME !== "crik18" &&
    HOUSE_NAME !== "one8";

  const menuList = (
    <ul className="flex flex-col font-helvetica text-[11px]">
      <li className="p-2 text-black text-xs font-bold bg-goldenYellow">
        {getUsername()}
      </li>
      {userMenuList.map(
        (
          {
            title,
            navigationUrl,
            enabled,
            langKey,
            openLanguageModal,
            isDownloadApk,
          },
          index,
        ) =>
          enabled && (
            <li
              key={index}
              className={`hover:underline cursor-pointer ${
                title === UserMenuEnum.SIGNOUT ? "" : "border-b border-b-gray18"
              }`}
            >
              {title === UserMenuEnum.SIGNOUT ? (
                <div
                  className="text-center bg-blue4 text-white py-2 font-bold text-xs"
                  onClick={() => {
                    dispatch(logout());
                    dispatch(
                      showToast({
                        type: "success",
                        message: "Logged out successfully",
                      }),
                    );
                  }}
                >
                  {langData?.["logout"]}
                </div>
              ) : openLanguageModal ? (
                <div className="px-2 py-1">
                  <button
                    type="button"
                    onClick={() => {
                      closeMenu();
                      setShowLanguageModal(true);
                    }}
                    className="cursor-pointer text-left w-full"
                  >
                    {langKey ? (langData?.[langKey] ?? title) : title}
                  </button>
                </div>
              ) : isDownloadApk ? (
                <div className="px-2 py-1">
                  <button
                    type="button"
                    onClick={() => {
                      closeMenu();
                      downloadApp();
                    }}
                    className="cursor-pointer text-left w-full apk-blink-animation"
                  >
                    {langKey ? (langData?.[langKey] ?? title) : title}
                  </button>
                </div>
              ) : (
                <div className="px-2 py-1">
                  <Link
                    to={navigationUrl || ""}
                    className={`cursor-pointer ${
                      langKey === "two_factor_auth" || title === "2FA"
                        ? "font-bold sidebar-blink-animation"
                        : ""
                    }`}
                  >
                    {langKey ? (langData?.[langKey] ?? title) : title}
                  </Link>
                </div>
              )}
            </li>
          ),
      )}
    </ul>
  );

  const handleWithdrawClick = () => {
    navigate(WITHDRAW_ROUTE);
  };

  const handleDepositClick = () => {
    navigate(DEPOSIT_ROUTE);
  };
  return (
    <div className="flex w-full flex-0 flex-col bg-[#010101]">
      <div
        className={`relative flex items-center justify-between border-0 p-2 shadow-none outline-none max-md:z-30 md:px-3 md:py-2 ${headerGradient}`}
      >
        <div className="flex md:gap-3 items-center">
          <img
            src={getEnvVariable(domain, "logo")}
            alt="logo"
            className={`md:my-2 lg:my-0 cursor-pointer ${getEnvVariable(domain, "logoClassName") || 'h-[43px] md:h-[40px] lg:h-[53px]'}`}
            onClick={() => navigate(`${HOME_ROUTE}`)}
          />

          {loggedIn && (
            <div className="hidden md:block">
              <HeaderSearchInput
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
            </div>
          )}
        </div>

        {loggedIn ? (
          <div className="flex gap-2 md:gap-1 items-center">
            {domainConfig?.payments && domainConfig.b2cEnabled && (
              <div className="hidden justify-center md:flex">
                {getUsername() !== "Demo User" && (
                  <>
                    <Button
                      onClick={handleDepositClick}
                      className="mx-1 flex w-fit items-center justify-center gap-2 rounded border border-white bg-[#008000] px-1 text-[10px] md:px-2 md:py-[5px] md:text-xs"
                    >
                      <span className="my-auto text-white">
                        {langData?.["deposit"]}
                      </span>
                    </Button>

                    <Button
                      onClick={handleWithdrawClick}
                      className="mx-1 flex w-fit items-center justify-center gap-2 rounded border border-white bg-[#FF0000] px-1 py-[2px] text-[10px] md:px-2 md:py-[5px] md:text-xs"
                    >
                      <span className="my-auto text-white">
                        {langData?.["withdraw"]}
                      </span>
                    </Button>
                  </>
                )}
              </div>
            )}
            <div className="flex items-center gap-2 md:gap-2.5">
              <div className="flex flex-row-reverse md:flex-row items-center gap-1">
                {isDesktop ? (
                  <>
                    <div className="hidden md:flex items-stretch h-[40px] rounded-md border border-[#5c5c5c] px-3 py-1 text-[12px] leading-tight bg-[rgba(0,0,0,.3)]">
                      <div className="flex flex-col justify-center gap-0.5 flex-1 min-w-0">
                      <div className="flex justify-between gap-2">
                        <span className="text-[#ffb600]">
                          {langData?.["main_balance"] ?? "Main Balance"}
                        </span>
                        <span className="font-bold text-[#ffb600]">
                          {((Number(balance) - (exposure ? Number(exposure) : 0)) / cFactor)?.toFixed(2)}
                        </span>
                      </div>
                      <div className="flex justify-between gap-2">
                        <span className="text-[#ffb600]">
                          {langData?.["exposure"] ?? "Exposure"}
                        </span>
                        <span
                          className="font-bold text-[#ffb600] cursor-pointer"
                          onClick={() => setShowOpenBets(true)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && setShowOpenBets(true)
                          }
                          role="button"
                          tabIndex={0}
                        >
                          {Number(exposure / cFactor)?.toFixed(2)}
                        </span>
                      </div>
                      {/* <button
                        type="button"
                        onClick={() => dispatch(fetchBalance())}
                        className="p-0.5 text-[#ffb600] hover:text-amber-300"
                        aria-label="Refresh balance"
                      >
                        <RefreshCw className="h-4 w-4" />
                      </button> */}
                      </div>

                    {/* Info sits in its own compartment inside the panel */}
                    {showBalanceInfoIcon && (
                      <div
                        className="relative flex items-center border-l border-[#5c5c5c] ml-2 pl-2"
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <button
                          type="button"
                          className="p-0.5 text-[#ffb600] hover:text-amber-300 cursor-pointer"
                          aria-label="Balance details"
                          onClick={() => setShowTooltip((v) => !v)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              setShowTooltip((v) => !v);
                            }
                          }}
                          role="button"
                          tabIndex={0}
                        >
                          <FaInfoCircle className="h-4 w-4" />
                        </button>
                        {showTooltip && (
                          <div className="absolute right-0 top-full mt-2 w-max max-w-[300px] p-2 bg-gray-800 text-white text-[12px] rounded shadow-lg z-50">
                            <div>
                              {langData?.["cashable"] ?? "Cashable"}: {cashableDisplay}
                            </div>
                            <div className="whitespace-nowrap">
                              {langData?.["non_cashable"] ?? "Non-cashable"}: {nonCashableDisplay}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    </div>

                    <div className="relative hidden md:flex gap-1">
                      <MenuComponent
                        menuList={menuList}
                        menuTitle={<FaGear className="h-4 w-4" />}
                        customButtonCss="text-black rounded-md h-[30px] w-[30px] shrink-0 flex items-center justify-center no-underline hover:no-underline bg-goldenYellow shadow-[inset_0_2px_0_0_rgba(255,255,255,.3)]"
                        toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                        isOpen={isMenuOpen}
                        closeMenu={closeMenu}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    
                    <div className="relative flex md:hidden">
                      <MenuComponent
                        menuList={menuList}
                        menuTitle={<FaGear className="h-4 w-4" />}
                        customButtonCss="text-black rounded-md h-[32px] w-[32px] shrink-0 flex items-center justify-center no-underline hover:no-underline bg-goldenYellow shadow-[inset_0_2px_0_0_rgba(255,255,255,.3)]"
                        toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                        isOpen={isMenuOpen}
                        closeMenu={closeMenu}
                      />
                    </div>
                    <div
                      className="md:hidden flex items-stretch h-[40px] flex-1 min-w-0 max-w-[235px] rounded-md border border-[#ffb600] px-2 py-1 text-[12px] leading-tight bg-header-gradient"
                      role="presentation"
                    >
                      <div className="flex flex-col justify-center gap-0.5 flex-1 min-w-0">
                      <div className="flex justify-between gap-2">
                        <span className="text-[#ffb600]/80">
                          {langData?.["bal"] ?? "Bal"}:
                        </span>
                        <span className="font-bold text-[#ffb600]">
                          {((Number(balance) - Number(exposure)) / cFactor)?.toFixed(2)}
                        </span>
                      </div>
                      <div className="flex justify-between gap-2">
                        <span
                          className="text-[#ffb600]/80 cursor-pointer"
                          onClick={() => setShowOpenBets(true)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && setShowOpenBets(true)
                          }
                          role="button"
                          tabIndex={0}
                        >
                          {langData?.["exp"] ?? "Exp"}
                        </span>
                        <span
                          className="font-bold text-[#ffb600] cursor-pointer"
                          onClick={() => setShowOpenBets(true)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && setShowOpenBets(true)
                          }
                          role="button"
                          tabIndex={0}
                        >
                          {Number(exposure / cFactor)?.toFixed(2)}
                        </span>
                      </div>
                      </div>

                      {/* Info sits beside the balance, divider before the chip */}
                      {showBalanceInfoIcon && (
                        <div
                          ref={mobileTooltipRef}
                          className="relative flex items-center ml-2"
                        >
                          <button
                            type="button"
                            className="p-0.5 text-[#ffb600] hover:text-amber-300 cursor-pointer"
                            aria-label="Balance details"
                            onClick={() => setShowTooltip((v) => !v)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setShowTooltip((v) => !v);
                              }
                            }}
                            role="button"
                            tabIndex={0}
                          >
                            <FaInfoCircle className="h-[22px] w-[22px]" />
                          </button>
                          <button
                            type="button"
                            className="ml-2 flex shrink-0 cursor-pointer items-center border-l border-[#ffb600] pl-2 transition-opacity hover:opacity-80"
                            aria-label={langData?.["my_market"] ?? "My Market"}
                            onClick={() => setShowOpenBets(true)}
                          >
                            <img
                              src={CasinoChipIcon}
                              alt=""
                              className="h-[22px] w-[22px]"
                            />
                          </button>
                          {showTooltip && (
                            <div className="absolute right-0 top-full mt-2 w-max max-w-[300px] p-2 bg-gray-800 text-white text-[10px] rounded shadow-lg z-50">
                              <div>
                                {langData?.["cashable"] ?? "Cashable"}: {cashableDisplay}
                              </div>
                              <div className="whitespace-nowrap">
                                {langData?.["non_cashable"] ?? "Non-cashable"}: {nonCashableDisplay}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>

              {showToggleSkins ? (
                <div className="flex items-center shrink-0 mt-1">
                  {ToggleSkins()}
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <div className="flex gap-1">
            <LoginButtons />
          </div>
        )}
      </div>

      {pathName === `${HOME_ROUTE}` && isMobile && (
        <div className="flex flex-col md:hidden">
          <NewsAndPromotions />
          {loggedIn &&
            domainConfig?.payments &&
            domainConfig.b2cEnabled &&
            getUsername() !== "Demo User" && (
              <WithdrawAndDepositBar
                onDepositClick={handleDepositClick}
                onWithdrawClick={handleWithdrawClick}
              />
            )}
        </div>
      )}

      <div className="relative z-10 w-screen overflow-visible hide-scrollbar bg-sub-header-gradient text-black max-md:hidden">
        <SubHeader disableSportsSubheader={disableSportsSubheader} />
      </div>
      <Modal
        isOpen={showOpenBets}
        onClose={() => {
          setShowOpenBets(false);
        }}
        title={langData?.["my_market"]}
        modalBg="bg-section-gradient"
      >
        <AllOpenBets setShowOpenBets={setShowOpenBets} />
      </Modal>
      <ChangeLanguageModal
        isOpen={showLanguageModal}
        onClose={() => setShowLanguageModal(false)}
      />
    </div>
  );
};
export default Header;
